"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    rocDate: {},
    phoneNumberWithCountryCode: {
        countryCode: "+1",
    },
};
